import { actionTypes } from "./storeTypes";

export const init_local = {
  horizon: { rawdata: [] },
  horizonFiltered: {},
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_HORIZON: {
      return {
        ...state,
        horizon: action.payload,
      };
    }
    case actionTypes.SET_HORIZON_FILTERED: {
      return {
        ...state,
        horizonFiltered: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
